import { TimekeepingComponent } from "../../components";

export default function TimekeepingOnlineApprovalPage() {
  return <TimekeepingComponent.TimeKeepingOnlineApprovalList />;
}
